import React from "react"

function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

type ButtonVariant = 'default' | 'crayon' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
type ButtonSize = 'default' | 'sm' | 'lg' | 'icon';

const buttonVariants: Record<ButtonVariant, string> = {
  default: "bg-[#0C7C86] text-white hover:bg-[#095f66] shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-x-[2px] active:translate-y-[2px]",
  crayon: "crayon-button text-white font-crayon tracking-wide text-lg",
  destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  outline: "border-2 border-[#0C7C86] text-[#0C7C86] hover:bg-[#0C7C86]/10",
  secondary: "bg-[#0C7C86]/10 text-[#0C7C86] hover:bg-[#0C7C86]/20",
  ghost: "text-[#0C7C86] hover:bg-[#0C7C86]/10",
  link: "text-[#0C7C86] underline-offset-4 hover:underline",
}

const buttonSizes: Record<ButtonSize, string> = {
  default: "h-11 px-6 py-2 rounded-xl",
  sm: "h-9 rounded-lg px-3",
  lg: "h-14 rounded-2xl px-8 text-lg",
  icon: "h-11 w-11 rounded-full",
}

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = "default",
  size = "default",
  ...props
}, ref) => {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap font-bold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        buttonVariants[variant],
        buttonSizes[size],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
